import React from "react";
import { Col, Container, Row } from "react-bootstrap";

import research from "../../assets/img/Research.webp";

const ResearchSummary = () => {
  return (
    <>
      <section className="section-spacing-x section-spacing-y">
        <Container fluid>
          <div className="row">
            <h1 className="heading mb-3 text-center">Research</h1>
            {/* <Row>
              <Col lg={7} className="mb-4">
                <p className="para-content mb-3">
                  At SHDL, we understand well the importance of research in
                  order to push forward the boundaries of knowledge. The diamond
                  industry is not static, but rather a dynamic and constantly
                  evolving business.
                </p>
                <p className="para-content mb-3">
                  Although diamond cutting and polishing has been taking place
                  for hundreds of years, there are continuous changes and
                  innovations and part of the reason for that is the research
                  that is undertaken by a broad range of institutions,
                  particularly by gem labs.
                </p>
                <p className="para-content mb-0">
                  Our research is targeted at developing ways to quickly
                  identify diamonds and any problems or issues they may have.
                </p>
              </Col>
              <Col lg={5} className="mb-4">
                <div className=" w-100 research-img">
                  <img src={research2} alt="" className="w-100 img-fluid" />
                </div>
              </Col>

              <Col lg={5}>
                <p className="para-content ">
                  We aim to find practical solutions as part of our research for
                  our valued clients. If you have a question relating to a
                  certain size, cut, color or clarity of a stone we are happy to
                  provide our assistance which is based on the deep experience
                  and skills of our staff. Please feel free to contact us with
                  any questions you may have. Although diamond cutting and
                  polishing has been taking place for hundreds of years, there
                  are continuous changes and innovations and part of the reason
                  for that is the research that is undertaken by a broad range
                  of institutions, particularly by gem labs.
                </p>
              </Col>
              <Col lg={7} className="pt-2">
                <div className=" w-100 research-img">
                  <img src={research1} alt="" className="w-100 img-fluid" />
                </div>
              </Col>
            </Row> */}
            <div className="col-lg-4">
              <div className="research-image mb-lg-0 mb-3">
                <img src={research} alt="about" className="img-fluid" />
              </div>
            </div>
            <div className="col-lg-8">
              <p className="mb-1">
                At SHDL, we understand well the importance of research in order
                to push forward the boundaries of knowledge. The diamond
                industry is not static, but rather a dynamic and constantly
                evolving business.
              </p>
              <p className="mb-1">
                Although diamond cutting and polishing has been taking place for
                hundreds of years, there are continuous changes and innovations
                and part of the reason for that is the research that is
                undertaken by a broad range of institutions, particularly by gem
                labs.
              </p>
              <p className="mb-1">
                Our research is targeted at developing ways to quickly identify
                diamonds and any problems or issues they may have.
              </p>
              <p className="mb-1">
                We aim to find practical solutions as part of our research for
                our valued clients. If you have a question relating to a certain
                size, cut, color or clarity of a stone we are happy to provide
                our assistance which is based on the deep experience and skills
                of our staff. Please feel free to contact us with any questions
                you may have.{" "}
              </p>
              <p className="research-content">
                Although diamond cutting and polishing has been taking place for
                hundreds of years, there are continuous changes and innovations
                and part of the reason for that is the research that is
                undertaken by a broad range of institutions, particularly by gem
                labs.
              </p>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default ResearchSummary;
